import {
  AMOwnershipEntityPreviewResponse,
  AMOwnershipEntityGraphOverview,
  AMOwnershipGetEntityGraphOverviewRequest,
  AMOwnershipEntitySearchResult,
  AMOwnershipGetEntitiesByIdsRequest,
  AMOwnershipGetParcelByIdRequest,
  AMOwnershipGetParcelByIdResponse,
  AMOwnershipGetParcelPreviewRequest,
  AMOwnershipSearchEntitiesRequest,
  AMOwnershipSearchEntitiesResponse,
  AMOwnershipSearchSuggestionsRequest,
  AMOwnershipSearchSuggestionsResponse,
  AMOwnershipParcelComplete,
  AMOwnershipEntityOverviewResponse,
  AMOwnershipGetEntityAcquisitionOverviewRequest,
  AMOwnershipEntityAcquisitionOverview,
  AMOwnershipGetEntityGraphContactsRequest,
  AMOwnershipEntityGraphContact,
  AMOwnershipGetEntityGraphParcelsRequest,
  AMOwnershipEntityGraphParcel,
  AMOwnershipGetEntityPropertyTypeBreakdownRequest,
  AMOwnershipEntityPropertyTypeBreakdown,
  AMOwnershipGetEntityGraphVisualRequest,
  AMOwnershipGraphVisualResponse,
  AMParcelOverview,
  AMOwnershipSearchParcelsByFeaturesRequest,
  AMOwnershipEntityContactsAvailability,
  AMOwnershipGetParcelGraphVisualRequest,
  AMOwnershipGetParcelGraphContactsRequest,
  AMPoint,
  AMOwnershipEntity,
  AMOwnershipL5Entity,
  AMOwnershipRootEntity,
} from 'src/common-services'
import { BaseClient } from 'src/common-services/clients/base-client'

export class OwnershipClient extends BaseClient {
  getSearchSuggestions(request: AMOwnershipSearchSuggestionsRequest) {
    return this.call<AMOwnershipSearchSuggestionsResponse>('/v2/ownership/search-suggestions', 'POST', {
      data: request,
    })
  }
  getEntityPreview(id: string) {
    return this.call<AMOwnershipEntityPreviewResponse>(`/v2/ownership/entities/${id}/preview`, 'GET')
  }

  getEntityOverview(id: string) {
    return this.call<AMOwnershipEntityOverviewResponse>(`/v2/ownership/entities/${id}/overview`, 'GET')
  }

  getEntityGraphVisualDirect(id: AMOwnershipGetEntityGraphVisualRequest) {
    return this.call<AMOwnershipGraphVisualResponse>(`/v2/ownership/entities/${id}/graph/visual-direct`, 'GET')
  }

  getEntityGraphOverview(id: AMOwnershipGetEntityGraphOverviewRequest) {
    return this.call<AMOwnershipEntityGraphOverview>(`/v2/ownership/entities/${id}/graph/overview`, 'GET')
  }

  getEntityPropertyTypeBreakdown(id: AMOwnershipGetEntityPropertyTypeBreakdownRequest) {
    return this.call<AMOwnershipEntityPropertyTypeBreakdown>(
      `/v2/ownership/entities/${id}/property-type-breakdown`,
      'GET'
    )
  }

  getEntitySummary(id: AMOwnershipGetEntityAcquisitionOverviewRequest) {
    return this.call<AMOwnershipEntityAcquisitionOverview>(`/v2/ownership/entities/${id}/entity-summary`, 'GET')
  }

  getEntityParcelsOverview(id: string): Promise<AMParcelOverview[]> {
    return this.call<AMParcelOverview[]>(`/v2/ownership/entities/${id}/parcels-overview`, 'GET')
  }

  getEntityGraphContacts(id: AMOwnershipGetEntityGraphContactsRequest) {
    return this.call<AMOwnershipEntityGraphContact[]>(`/v2/ownership/entities/${id}/graph/contacts`, 'GET')
  }

  getEntityContactsAvailability(id: string) {
    return this.call<AMOwnershipEntityContactsAvailability>(`/v2/ownership/entities/${id}/contacts-availability`, 'GET')
  }

  getEntityGraphRelatedEntities(id: AMOwnershipGetEntityGraphContactsRequest) {
    return this.call<AMOwnershipEntity[]>(`/v2/ownership/entities/${id}/graph/related-entities`, 'GET')
  }

  getEntityGraphParcels(id: AMOwnershipGetEntityGraphParcelsRequest) {
    return this.call<AMOwnershipEntityGraphParcel[]>(`/v2/ownership/entities/${id}/graph/parcels`, 'GET')
  }

  searchEntitiesByQuery(request: AMOwnershipSearchEntitiesRequest) {
    return this.call<{ results: AMOwnershipSearchEntitiesResponse; total: number }>(
      '/v2/ownership/entities/search',
      'POST',
      {
        data: request,
      }
    )
  }

  getEntitiesByIds(ids: AMOwnershipGetEntitiesByIdsRequest) {
    return this.call<AMOwnershipEntitySearchResult[]>('/v2/ownership/entities/by-ids', 'POST', {
      data: ids,
    })
  }

  getParcelById(parcelId: AMOwnershipGetParcelByIdRequest) {
    return this.call<AMOwnershipGetParcelByIdResponse>(`/v2/ownership/parcel/${parcelId}`, 'GET')
  }

  getParcelPreviewById(parcelId: AMOwnershipGetParcelPreviewRequest) {
    return this.call<AMOwnershipGetParcelByIdResponse>(`/v2/ownership/parcel/${parcelId}/preview`, 'GET')
  }

  getParcelByPoint(point: AMPoint) {
    return this.call<AMOwnershipParcelComplete>('/v2/ownership/parcel/by-point', 'POST', {
      data: point,
    })
  }

  searchParcelsByFeatures(data: AMOwnershipSearchParcelsByFeaturesRequest) {
    return this.call<{ results: AMOwnershipParcelComplete[]; total: number }>(
      '/v2/ownership/parcels/search-by-features',
      'POST',
      {
        data,
      }
    )
  }

  getParcelGraphVisualDirect(id: AMOwnershipGetParcelGraphVisualRequest) {
    return this.call<AMOwnershipGraphVisualResponse>(`/v2/ownership/parcel/${id}/graph/visual-direct`, 'GET')
  }

  getParcelGraphContacts(id: AMOwnershipGetParcelGraphContactsRequest) {
    return this.call<AMOwnershipEntityGraphContact[]>(`/v2/ownership/parcel/${id}/graph/contacts`, 'GET')
  }

  getEntityL5Entities(id: string) {
    return this.call<AMOwnershipL5Entity[]>(`/v2/ownership/entities/${id}/l5-entities`, 'GET')
  }

  getRootEntitiesByEntityId(id: string) {
    return this.call<AMOwnershipRootEntity[]>(`/v2/ownership/entities/${id}/root-entities`, 'GET')
  }
}
